<div class="avatar" [class.profile-edit]="isProfileEdit" [class.empty]="!imageUrl && !firstLetter">
  @if (imageUrl && isProfileEdit) {
    <img [src]="imageUrl" alt="Avatar" class="avatar-img" />
  }
  @if (imageUrl && !isProfileEdit) {
    <img [src]="imageUrl" alt="Avatar" class="avatar-img-top" />
  }
  @if (!imageUrl && firstLetter) {
    <span>{{ firstLetter }}</span>
  }

  <!-- Edit icon shown when empty -->
  @if (!imageUrl && !firstLetter) {
    <mat-icon class="empty-icon">person</mat-icon>
  }

  <!-- Hover overlay -->
  @if (isProfileEdit) {
    <div class="avatar-overlay">
      <div class="overlay-icons">
        <button class="avatar-action" type="button" matTooltip="Change photo" aria-label="Change profile photo"
          (click)="openFileDialog()">
          <mat-icon>edit</mat-icon>
        </button>
        @if (imageUrl) {
          <div class="divider"></div>
        }
        @if (imageUrl) {
          <button class="avatar-action avatar-action--remove" type="button" matTooltip="Remove photo"
            aria-label="Remove profile photo" (click)="onDelete()">
            <mat-icon>delete_outline</mat-icon>
          </button>
        }
      </div>
    </div>
  }


  <input #fileInput type="file" accept="image/*" hidden (change)="onFileChange($event)" />
</div>
